import i18n from '@/i18n'

const t = (key: string, params?: Record<string, unknown>) =>
    i18n.global.t(key, params as any)

const STORE_IS_OPEN_CLASS = 'store-is-open'
const STORE_OPEN_SOON_CLASS = 'store-open-soon'
const STORE_CLOSE_CLASS = 'store-close'

// Localized status text getters
const getStoreIsOpenText = () => t('storeOpen')
const getStoreCloseText = () => t('storeClosed')
const getStoreOpenOrderClosedText = () => t('storeOpenOrderClosed')
const getStoreOpensAtText = (time: string | number | null) =>
    t('storeOpensAt', { time })
const getStoreClosedOpensOnText = (day: string, time: string | number | null) =>
    t('storeClosedOpensOn', { day, time })
const getStoreOrderOpenOpensAtText = (time: string | number | null) =>
    t('storeOrderOpenOpensAt', { time })

const getWeek = () => [
    t('dayFullSunday'),
    t('dayFullMonday'),
    t('dayFullTuesday'),
    t('dayFullWednesday'),
    t('dayFullThursday'),
    t('dayFullFriday'),
    t('dayFullSaturday')
]

export {
    STORE_IS_OPEN_CLASS,
    STORE_OPEN_SOON_CLASS,
    STORE_CLOSE_CLASS,

    getStoreIsOpenText,
    getStoreCloseText,
    getStoreOpenOrderClosedText,
    getStoreOpensAtText,
    getStoreClosedOpensOnText,
    getStoreOrderOpenOpensAtText,
    getWeek,
}
